import React from "react";
import style from "./index.module.scss";
import "moment/locale/zh-cn";

import SendMsg from "../../../SendMsg";
import { useSession } from "../../../../Utils/useSession";
import MessageList from "../../../MessageList";

interface ChatContainerProps {
    sessionId: string;
}

export default function ChatContainer({ sessionId }: ChatContainerProps) {
    const { session } = useSession(sessionId);

    return (
        <div className={style.root}>
            <div>
                <div className={style.header}>
                    <div>{session?.sessionTopic}</div>
                </div>

                <MessageList sessionId={sessionId} />

                <SendMsg sessionId={sessionId} />
            </div>
        </div>
    );
}
